// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__33yFt","actionsCol":"EnrolledClinics_actionsCol__3pvVR"};